module.exports = __webpack_public_path__ + "img/press.d5967f04.gif";